import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { DiscountRetrieve } from 'types';
import { client } from 'utils/api-client';

function useDiscount(discountId: string | undefined): UseQueryResult<AxiosResponse<DiscountRetrieve>> {
  return useQuery(['discounts', discountId], () => client.get(`discounts/${discountId}/`), {
    enabled: !!discountId,
  });
}

export default useDiscount;
